const comments = [
  {
    name: '追更达人小王',
    avatar: '王',
    time: '2小时前',
    text: '樱花动漫之家的新番更新速度真的快！每周四晚上准时刷新就能看到最新一集，比某些大站还快，追更动漫就靠这里了。',
    tag: '忠实用户',
  },
  {
    name: '动漫控阿琳',
    avatar: '琳',
    time: '5小时前',
    text: '最喜欢这里的番剧分类功能，热血番和恋爱番分得清清楚楚，不用在一堆番剧里翻来翻去，追更体验满分！',
    tag: '活跃追更',
  },
  {
    name: '新番猎人老张',
    avatar: '张',
    time: '1天前',
    text: '作为一个追了十几年动漫的老二次元，樱花动漫之家的番剧库真的很全，冷门佳作也能找到，强烈推荐给所有追更动漫的朋友。',
    tag: '资深用户',
  },
  {
    name: '追番少女糖糖',
    avatar: '糖',
    time: '2天前',
    text: '界面简洁没广告，手机端追更动漫特别方便！通勤路上就能追完一集，已经推荐给身边所有追番的小伙伴了。',
    tag: '新用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            追更者说
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            听听追更动漫的小伙伴们怎么说
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-semibold text-primary-600">{comment.avatar}</span>
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-900 truncate">{comment.name}</span>
                    <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 text-[10px] font-medium whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-500">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                "{comment.text}"
              </p>
              <div className="mt-3 flex items-center gap-0.5">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-xs text-accent-500"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}